import { apiFetch } from './api';

const API_URL = process.env.REACT_APP_API_URL || '/api';

/** Les paramètres vides ne sont pas transmis : le serveur applique ses défauts. */
function versQuery(params) {
  const query = new URLSearchParams();
  for (const [cle, valeur] of Object.entries(params)) {
    if (valeur !== undefined && valeur !== null && valeur !== '') query.set(cle, valeur);
  }
  const s = query.toString();
  return s ? `?${s}` : '';
}

/** Fichier clients (import Brevo + demandes), paginé. */
export function getClients(params = {}) {
  return apiFetch(`/clients${versQuery(params)}`);
}

/** Dossier complet : fiche, demandes, devis, contrats, pièces. */
export function getClientDossier(id) {
  return apiFetch(`/clients/${id}`);
}

export function createClient(data) {
  return apiFetch('/clients', { method: 'POST', body: JSON.stringify(data) });
}

/**
 * Supprime une fiche client. Ses demandes de devis restent, détachées de
 * la fiche. Renvoie { id, libelle, demandesDetachees }.
 */
export function deleteClient(id) {
  return apiFetch(`/clients/${id}`, { method: 'DELETE' });
}

export function updateClient(id, data) {
  return apiFetch(`/clients/${id}`, { method: 'PUT', body: JSON.stringify(data) });
}

/**
 * Import de l'export CSV Brevo. Multipart, pas JSON : le fichier part tel
 * quel, sans passer par une lecture côté navigateur. Le cookie de session
 * suit (credentials), comme pour apiFetch.
 */
export async function importerClientsCsv(fichier) {
  const corps = new FormData();
  corps.append('fichier', fichier);
  const res = await fetch(`${API_URL}/clients/import`, {
    method: 'POST',
    credentials: 'include',
    body: corps,
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(json?.message || `Import impossible (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return json;
}
